/**
 * 表情模块，负责表情的显示和交互效果
 * @author  lianghua.fu
 * @update 2015-12-10 11:03:03
 */

$.module('MM.util.expression', function () {
  var EXP_COL = {
    common: {
      ary: [
        '微笑',
        '撇嘴',
        '色',
        '得意',
        '流泪',
        '害羞',
        '睡',
        '大哭',
        '尴尬',
        '生气',
        '调皮',
        '呲牙',
        '惊讶',
        '难过',
        '酷',
        '冷汗',
        '淘气',
        '吐',
        '偷笑',
        '可爱',
        '白眼',
        '傲慢',
        '舔',
        '困',
        '惊恐',
        '汗',
        '大笑',
        '奋斗',
        '咒骂',
        '疑问',
        '嘘',
        '晕',
        '敲打',
        '拜拜',
        '擦汗',
        '抠鼻',
        '高兴',
        '糗大了',
        '窃笑',
        '左哼哼',
        '右哼哼',
        '哈欠',
        '鄙视',
        '委屈',
        '快哭了',
        '阴险',
        '亲亲',
        '可怜',
        '菜刀',
        '吃饭',
        '猪头',
        '吻',
        '爱心',
        '心碎',
        '便便',
        '月亮',
        '拥抱',
        '给力',
        '不给力',
        '握手',
        '胜利',
        '抱拳',
        '勾引',
        '拳头',
        '差劲',
        '爱你',
        'NO',
        'OK',
        '凋谢',
        '发呆',
        '大兵',
        '太阳',
        '炸弹',
        '玫瑰',
        '礼物',
        '蛋糕',
        '衰',
        '闭嘴',
        '骷髅',
        '干杯',
      ],
      prefix: '/',
      postfix: 'gif',
      root: MM.core.getRoot('styles/expression/common/', 'base'),
    },
    // vip  去掉vip表情，改为举人及以上 可用  2021-10-27 14:10:44
    svip: {
      ary: [
        '扮酷',
        '擦汗',
        '财迷',
        '超人',
        '聪明',
        '大哭',
        '大笑',
        '发怒',
        '鼓掌',
        '坏笑',
        '惊讶',
        '鞠躬',
        '可怜',
        '渴望',
        '劳累',
        '卖萌',
        '美人',
        '亲密',
        '亲亲',
        '失望',
        '睡觉',
        '思考',
        '跳舞',
        '吐舌头',
        '微笑',
        '我错了',
        '羞涩',
        '疑问',
        '晕',
        '钟爱',
        '撞墙',
        '抽耳光',
        '摸头',
        '群舞',
        '握手',
        '强吻',
      ],
      prefix: '/v',
      postfix: 'gif',
      root: MM.core.getRoot('styles/expression/svip/', 'base'),
    },
    // 2富及2富以上
    meme: {
      ary: [
        '亲吻屏幕',
        '买买买',
        '中毒',
        'ok',
        '偷听',
        '冒汗',
        '发火',
        '吃东西',
        '吃药',
        '吐舌头',
        '可怜',
        '吐血',
        '吵架',
        '吓宝宝',
        '呕吐',
        '哭笑',
        '大哭',
        '困',
        '委屈哭',
        '寂寞',
        '头晕',
        '心眼',
        '恐怖',
        '惊吓红嘴',
        '恶心',
        '打电话',
        '戴墨镜',
        '抠鼻子',
        '招手',
        '捂嘴笑',
        '摸胡子',
        '杀气',
        '流口水',
        '流鼻血',
        '烧焦',
        '生气',
        '中指',
        '疑惑',
        '砸蛋',
        '石化',
        '约吗',
        '耶',
        '肥皂',
        '色迷迷',
        '苦瓜脸',
        '要脸不',
        '通便器',
        '鄙视',
        '闭嘴',
        '露牙肉',
        '馋了',
        '鼓掌',
      ],
      prefix: '/m',
      postfix: 'png',
      root: MM.core.getRoot('styles/expression/meme/', 'base'),
    },
    //5富及5富以上
    level: {
      ary: [
        '你好',
        '冰激凌',
        '凯蒂猫',
        '不给力',
        '彩虹',
        '太阳',
        '亲亲',
        '冷汗',
        '可爱',
        '哭',
        '喜',
        '土豪献花',
        '大笑',
        '大黄鸭',
        '天真',
        '害羞',
        '开心',
        '晚安',
        '期盼',
        '机器猫',
        '棒',
        '樱花',
        '流汗',
        '海盗',
        '甜甜圈',
        '生气',
        '疑惑',
        '睡着',
        '绅士',
        '色',
        '蛋糕',
        '衰',
        '调皮',
        '轻松熊',
        '送爱心',
        '鼓掌',
        '生快',
      ],
      prefix: '/l',
      postfix: 'png',
      root: MM.core.getRoot('styles/expression/level/', 'base'),
    },
    // privilege: {
    //     ary: ["嘻嘻", "调皮", "哦哟", "惊讶", "我最闪亮", "大哭", "感动", "看电影", "快哭了", "你咬我呀", "两眼放光", "不行", "咧嘴", "发怒", "大叔", "纳尼", "飞眼", "不想说话", "被打", "咦", "微笑", "哈哈", "海滩"],
    //     prefix: '/s',
    //     postfix: 'png',
    //     root: MM.core.getRoot('styles/expression/privilege/', 'base')
    // }
  };

  var _expressionTmpl =
    '\
			<div class="common-box boxUp expression-box ">\
				<% for (var key in data) {%>\
					<% if (key === "common" || isShowAll) { \
					var expData = data[key], expAry = expData.ary; %>\
						<div class="nano exp-<%=key%>"><div class="content">\
							<ul class="fix">\
								<% for (var i = 0; i < expAry.length; i++) { var exp = expAry[i]; %>\
										<li data-exp="<%=expData.prefix+exp%>"><img src="<%=expData.root+exp+"."+(expData.postfix || "gif")%>" title="<%=exp%>" alt="<%=exp%>" /></li>\
								<% } %>\
							</ul>\
						</div></div>\
					<% } %>\
				<% } %>\
				<% if (isShowAll) { %>\
					<div class="exp-tab">\
						<span class="active" data-type="common"><i class=" icon-expression-base  icon-expression-common"></i></span>\
						<span data-type="meme"><i class="icon-expression-base icon-expression-meme"></i></span>\
						<span data-type="level"><i class="icon-expression-base  icon-expression-level"></i></span>\
						<span data-type="svip"><i class="icon-expression-base  icon-expression-svip"></i></span>\
						<!-- <span data-type="privilege"><i class="icon-expression-base  icon-expression-privilege"></i></span> -->\
					</div>\
				<% } %>\
			</div>\
		';

  //<span data-type="privilege"><i class="icon-expression-base  icon-expression-privilege"></i></span>

  /**
   * [表情模块，负责表情控制]
   * @param  {[Object]} $area     [要插入的区域]
   * @param  {[Object]} $btn      [控制的按钮]
   * @param  {[Object]} $textArea [需要插入文本的输入框]
   * @param  {Boolean} isShowAll 是否需要显示vip的表情
   */
  var _expressionController = function (
    $area,
    $btn,
    $textArea,
    isShowAll,
    isStar,
  ) {
    this.$area = $area;
    this.$btn = $btn;
    this.$textArea = $textArea;
    this.$expBox = null;
    this.$tab = null;
    this.isShowAll = isShowAll || false;

    this.isStar = isStar || false;

    var that = this;

    function _registerEvents() {
      that.$btn.click(function (e) {
        if (!that.$expBox) {
          that.$area.append(
            $.template(_expressionTmpl, {
              data: EXP_COL,
              isShowAll: that.isShowAll,
            }),
          );

          that.$expBox = that.$area.find('.expression-box');
          that.$tab = that.$expBox.children('div');

          //if (!!that.$expBox.find('.nano').nanoScroller) {
          //	that.$expBox.find('.nano').nanoScroller();
          //}

          _registerAfterRender();
        }

        that.$expBox.toggle();
      });
    }

    function _registerAfterRender() {
      // 绑定表情
      that.$expBox.delegate('li', 'click', function (e) {
        var $this = $(this),
          exp = $this.data('exp');

        _insertAtCursor(that.$textArea[0], exp);

        that.$textArea.trigger('keydown');
      });

      that.$expBox.on('mouseleave', function (e) {
        MM.core.debug('mouseleave hide');

        $(this).hide();
      });

      if (!that.isShowAll) {
        return;
      }

      that.$tab.delegate('span', 'click', function (e) {
        var $this = $(this),
          type = $this.data('type');

        if (type === 'svip' && MM.user.getRichLv() < 11 && !that.isStar) {
          return MM.ui.messager.warn('您还未达到举人等级，无法使用专属表情');
        }

        if (type === 'meme' && MM.user.getRichLv() < 4 && !that.isStar) {
          return MM.ui.messager.warn('您还未达到四富等级，无法使用专属表情');
        }

        if (type === 'level' && MM.user.getRichLv() < 5 && !that.isStar) {
          return MM.ui.messager.warn('您还未达到五富等级，无法使用专属表情');
        }

        // if (exp.indexOf('/s') > -1 && MM.user.getUserInfo().m_vip < 3 && !that.isStar) {
        //     return MM.ui.messager.warn('您还不是M3特权及以上用户，无法使用专属表情');
        // }

        $this.addClass('active').siblings().removeClass('active');
        that.$area
          .find('.exp-' + type)
          .show()
          .siblings('.nano')
          .hide();
        //if (!!that.$expBox.find('.nano').nanoScroller) {
        //	that.$expBox.find('.nano').nanoScroller();
        //}
      });
    }

    _registerEvents();
  };

  _expressionController.prototype.show = function () {
    if (!this.$expBox) {
      return;
    }

    this.$expBox.show();
  };

  _expressionController.prototype.hide = function () {
    if (!this.$expBox) {
      return;
    }

    this.$expBox.hide();
  };

  function _replaceExp(type, text, isEnable) {
    var exp = EXP_COL[type],
      ary = EXP_COL[type].ary,
      length = ary.length;

    for (var i = 0; i < length; i++) {
      var item = ary[i],
        tempReg = new RegExp(exp.prefix + item, 'g');

      if (isEnable) {
        text = text.replace(
          tempReg,
          '<img class="exp-img" title=' +
            item +
            ' alt=' +
            item +
            ' src=' +
            exp.root +
            item +
            '.' +
            exp.postfix +
            ' />',
        );
      } else {
        text = text.replace(tempReg, '');
      }
    }

    return text;
  }

  /**
   * 替换表情，同时替换普通和vip表情
   * @param  {String}  text  文本
   * @param  {Boolean} isVip 是否是vip
   * @param  {Boolean} isLevel 是否到达等级
   * @param  {Boolean} isStar 是否是主播
   */
  function _replaceAllExp(text, opt) {
    var _opt = $.extend(
      {
        vip: 0,
        level: 0,
        isStar: 0,
        mvip: 0,
      },
      opt,
    );

    text = _replaceExp('common', text, true);
    text = _replaceExp('svip', text, _opt.level > 10 || _opt.isStar);
    // text = _replaceExp('privilege', text, ((_opt.mvip && _opt.mvip >= 3) || _opt.isStar));
    text = _replaceExp('level', text, _opt.level >= 5 || _opt.isStar);
    text = _replaceExp('meme', text, _opt.level >= 2 || _opt.isStar);

    return text;
  }

  function _replaceExpression(text) {
    return _replaceExp('common', text, true);
  }

  /**
   * 判断是否有vip/等级表情
   * @param  {String}  text 文本
   * @param  {String}  type svip/level
   * @return {Boolean}      [description]
   */
  function _hasExp(text, type) {
    type = type || 'svip';

    var ary = EXP_COL[type].ary,
      length = ary.length,
      prefix = EXP_COL[type].prefix,
      flag = false;

    for (var i = 0; i < length; i++) {
      var expression = ary[i];

      if (text.indexOf(prefix + expression) > -1) {
        flag = true;
        break;
      }
    }

    return flag;
  }

  //在光标处插入文字
  function _insertAtCursor(txtarea, text) {
    var scrollPos = txtarea.scrollTop,
      strPos = 0,
      br =
        txtarea.selectionStart || txtarea.selectionStart == '0'
          ? 'ff'
          : document.selection
          ? 'ie'
          : false;

    if (br == 'ie') {
      txtarea.focus();
      var range = document.selection.createRange();
      range.moveStart('character', -txtarea.value.length);
      strPos = range.text.length;
    } else if (br == 'ff') {
      strPos = txtarea.selectionStart;
    }

    var front = txtarea.value.substring(0, strPos),
      back = txtarea.value.substring(strPos, txtarea.value.length);

    txtarea.value = front + text + back;
    strPos = strPos + text.length;

    if (br == 'ie') {
      txtarea.focus();
      var range = document.selection.createRange();
      range.moveStart('character', -txtarea.value.length);
      range.moveStart('character', strPos);
      range.moveEnd('character', 0);
      range.select();
    } else if (br == 'ff') {
      txtarea.selectionStart = strPos;
      txtarea.selectionEnd = strPos;
      txtarea.focus();
    }

    txtarea.scrollTop = scrollPos;
  }

  return {
    create: function ($area, $btn, $textArea, isShowAll, isStar) {
      return new _expressionController(
        $area,
        $btn,
        $textArea,
        isShowAll,
        isStar,
      );
    },
    replaceExpression: _replaceExpression,
    replaceAllExp: _replaceAllExp,
    hasExp: _hasExp,
  };
});
